<template lang="pug">
erp-view(
  id="ConfiguracionSeguridad"
  ref="ConfiguracionSeguridad"
  title="Configuración de Seguridad"
  hide-header-title=true
  hide-header-action=true
)
  template(slot="content")
    div.configuracion-container
      // 🔹 Encabezado principal
      div.header
        div.header-left
          i.fa.fa-shield-alt.header-icon
          div.header-text
            h2 Configuración de Seguridad
            p Control central de usuarios, roles y permisos del sistema.
        div.header-right
          span.status-label Sistema Activo
          i.fa.fa-circle.active-indicator

      // 🔹 Cuerpo principal
    div.main-content
      ControlUsuarios

        //dx-tab-panel(
          :selected-index.sync="tabIndex"
          :animation-enabled="true"
          :loop="false"
          :defer-rendering="true"
          class="seguridad-tabs"
          )
          dx-item(v-for="tab in tabs" :key="tab.name" :title="tab.title")
            template(#default)
</template>

<script>
import ControlRoles from "./tabs/ControlRoles.vue"
import ControlUsuarios from "./tabs/ControlUsuarios.vue"
import ControlPermisos from "./tabs/ControlPermisos.vue"

export default {
  name: "ConfiguracionSeguridad",
  components: { ControlUsuarios, ControlRoles, ControlPermisos },
  data() {
    return {
      tabIndex: 0,
      tabs: [
        { name: "usuarios", title: "Usuarios", component: ControlUsuarios },
        { name: "roles", title: "Roles", component: ControlRoles },
        { name: "permisos", title: "Permisos", component: ControlPermisos },
      ],
    };
  },
};
</script>

<style scoped>
/* ===== CONTENEDOR GENERAL ===== */
.configuracion-container {
  background: #f9fafb;
  border-radius: 12px;
  padding: 20px;
  margin-top: -8px;
  font-family: 'Inter', sans-serif;
  color: #1f2937;
}

/* ===== ENCABEZADO ===== */
.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: linear-gradient(90deg, #2563eb, #3b82f6);
  color: white;
  padding: 16px 20px;
  border-radius: 12px;
  margin-bottom: 20px;
  box-shadow: 0 3px 8px rgba(0, 0, 0, 0.1);
}

.header-left {
  display: flex;
  align-items: center;
}

.header-icon {
  font-size: 1.8rem;
  background-color: rgba(255, 255, 255, 0.25);
  padding: 10px;
  border-radius: 50%;
  margin-right: 14px;
}

.header-text h2 {
  font-size: 1.3rem;
  font-weight: 600;
  margin: 0;
  letter-spacing: 0.3px;
}

.header-text p {
  font-size: 0.9rem;
  margin: 2px 0 0;
  color: rgba(255, 255, 255, 0.85);
}

/* Estado a la derecha */
.header-right {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 0.9rem;
}

.status-label {
  background-color: rgba(255, 255, 255, 0.2);
  padding: 6px 10px;
  border-radius: 8px;
  font-weight: 500;
}

.active-indicator {
  color: #22c55e;
  font-size: 0.8rem;
}

/* ===== TABS ===== */
.seguridad-tabs {
  background-color: white;
  border-radius: 12px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.05);
  padding: 10px;
}

/* Pestañas */
.seguridad-tabs .dx-tab {
  background-color: #f3f4f6 !important;
  border-radius: 10px 10px 0 0 !important;
  color: #4b5563 !important;
  font-weight: 500;
  transition: all 0.25s ease-in-out;
  margin-right: 6px;
  padding: 10px 18px !important;
  font-size: 0.95rem;
}

.seguridad-tabs .dx-tab:hover {
  background-color: #e5e7eb !important;
  color: #1e3a8a !important;
}

.seguridad-tabs .dx-tab.dx-tab-selected {
  background-color: #ffffff !important;
  color: #1d4ed8 !important;
  border-bottom: 3px solid #2563eb !important;
  font-weight: 600;
  box-shadow: 0 -2px 6px rgba(37, 99, 235, 0.1);
}

/* Contenido */
.seguridad-tabs .dx-multiview-wrapper {
  background-color: #ffffff;
  border-radius: 0 0 12px 12px;
  padding: 15px;
}

 
</style>
